import { withJsonFormsControlProps } from '@jsonforms/react';
import { CustomRendererProps } from '../types';
import { SchemaData } from 'layouts/aplicacoes/Events/hooks/types';
import { CertificateManagement } from 'layouts/aplicacoes/Events/components/CertificateManagement';
import { CertificatePreview } from 'layouts/aplicacoes/Events/components/CertificatePreview';
function Renderer({data,uischema}:CustomRendererProps<SchemaData>){return uischema?.options?.previewOnly?<CertificatePreview data={data}/>:data?.id?<CertificateManagement eventId={Number(data.id)}/>:null}
export default withJsonFormsControlProps(Renderer);
